module.exports = __webpack_public_path__ + "img/dark-circles.55546baa.svg";